import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { TAG_CLICK_TRAVEL_OPTIONS_MODEFAVORI } from '../analytics/analytics.tagids.constants'
import { selectFavouriteModes, selectPreferredMode } from '../../store/itineraryOptions/itineraryOptions.selectors'
import { setPreferredMode } from '../../store/itineraryOptions/itineraryOptionsSlice'
import { SELECTION } from '../analytics/ClickTagsService'
import useConfigureAndSendTag from '../analytics/useConfigureAndSendTag'
import ModeItem from '../itinerary/ModeItem'
import sModeSelector from '../itinerary/ModeSelector.less'

const FavouriteModeBox = () => {
  const favouriteModes = useSelector(selectFavouriteModes)
  const preferredMode = useSelector(selectPreferredMode)
  const dispatch = useDispatch()
  const configureAndSendTag = useConfigureAndSendTag()

  const onClickForId = id => () => {
    configureAndSendTag({
      type: TAG_CLICK_TRAVEL_OPTIONS_MODEFAVORI,
      tagInfo: {
        [SELECTION]: id
      }
    })
    dispatch(setPreferredMode({ modeId: id }))
  }

  return (
    <ul>
      {favouriteModes.map(({ id, label, icon }) => {
        return (
          <li className={sModeSelector.listItemFavorites} key={id}>
            <ModeItem
              selected={preferredMode === id}
              icon={icon}
              description={label}
              onClick={onClickForId(id)}
              displayHighlightBar={false}
            />
          </li>
        )
      })}
    </ul>
  )
}

export default FavouriteModeBox
